import { render, staticRenderFns } from "./AddInlandVesselPractice.vue?vue&type=template&id=0ed0f69a"
import script from "./AddInlandVesselPractice.vue?vue&type=script&lang=ts"
export * from "./AddInlandVesselPractice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports